import{a as n}from"./chunk-RAAYCPUM.js";function y(...r){return n(l,r)}function l(r,t,a,o){let e=[...r];return e.splice(t,a,...o),e}export{y as a};
